/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Profile_Security_User_Api_Key_Cleanup_SuccessInputs */



/**
* | output |
* | --- |
* | "{count} expired key(s) deleted." |
*
* @param {Profile_Security_User_Api_Key_Cleanup_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_user_api_key_cleanup_success = /** @type {((inputs: Profile_Security_User_Api_Key_Cleanup_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_User_Api_Key_Cleanup_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} abgelaufene(r) Schlüssel gelöscht.`)
	return /** @type {LocalizedString} */ (`${i?.count} expired key(s) deleted.`)
});